<template>
  <div class="container">
    <estrella v-for="(i, index) in 10" :key="`fija-${index}`"></estrella>
    <estrella-fugaz v-for="(i, index) in 5" :key="`fugaz-${index}`"></estrella-fugaz>
    <img class="ladera-izq" src="@/assets/img/splash_screen/LaderaIzq.png">
    <img class="ladera-der" src="@/assets/img/splash_screen/LaderaDer.png">
    <img class="logo-cpe" alt="CPE" src="@/assets/img/splash_screen/CPE.png">
    <div class="logo-pyp">
      <img alt="Prendo & Aprendo" src="@/assets/img/splash_screen/Prendo&Aprendo.png">
    </div>
    <div class="bottom" :style="{'flex-grow': ready ? 1 : 0}">
        <div class="btn btn-primary btn-entrar" :style="{'opacity': ready ? 1 : 0}" @click="start">{{btn_start}}</div>
    </div>
    <div class="mensaje">
      <div class="wraper">
        <img class="marciano" src="@/assets/img/splash_screen/Marciano.png" alt="">
        <div class="caja-texto">
          <span>{{msg}}</span>
        </div>
      </div>
    </div>
    <img class="logo-mintic" src="@/assets/img/splash_screen/MinTIC.png" alt="">
  </div>
</template>
<script>
import Estrella from '@/components/Estrella.vue'
import EstrellaFugaz from '@/components/EstrellaFugaz.vue'
export default {
  name: 'splash',
  components: {
    Estrella,
    EstrellaFugaz,
  },
  data(){
    return {
      ready: false
    }
  },
  computed:{
    btn_start(){
      return this.$store.getters.splashScreen.texto_boton_start;
    },
    msg(){
      return this.$store.getters.splashScreen.mensaje_marciano;
    }
  },
  methods:{
    start(){
      this.$globalEvent.$emit('buttonSound');
      this.$router.replace({ name: 'home' });
    }
  },
  mounted(){
    setTimeout(() => {
      // this.start();
      this.ready = true;
    }, 4000);
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/responsiveness.scss";

  .container{
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url("~@/assets/img/splash_screen/Background.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    // background: #40519f;
    // background: linear-gradient(to bottom, #40519f 0%,#40519f 41%,#d64d51 84%,#d64d51 100%);
  }

  // .background, .backgroun2{
  //   width: 100%;
  //   height: 100%;
  //   position: absolute;
  //   top: 0px;
  //   left: 0px;    
  // }

  // .background{
  //   background-image: url("~@/assets/img/splash_screen/Background.png");
  //   background-position: center;
  //   background-repeat: no-repeat;
  //   background-size: cover;
  // }

  // .backgroun2{
  //   background-image: url("~@/assets/img/splash_screen/Foreground.png");
  //   background-position: bottom;
  //   background-repeat: no-repeat;
  //   background-size: contain;
  // }

  .logo-pyp{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 250px;
    max-width: 70%;
    z-index: 1;
    flex-grow: 1;
    transition: flex-grow 500ms ease-in-out;
  }

  .logo-pyp>img{
    filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));
    max-width: 100%;
  }

  .logo-cpe{
    position: fixed;
    left: 15px;
    top: 15px;
    width: 200px;
    max-width: 30%;
  }

  .logo-mintic{
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 350px;
    max-width: 45%;
    @include mobile{
      top: 0px;
      max-width: 60%;
    }
  }

  .ladera-izq, .ladera-der{
    position: fixed;
    bottom: 0px;
    max-width: 50%;
  }

  .ladera-izq{
    left: 0px;
  }

  .ladera-der{
    right: 0px;
  }

  .bottom{
    flex-grow: 0;
    transition: flex-grow 500ms ease-in-out;
    z-index: 1;
  }

  .mensaje{
    position: absolute;
    bottom: 0px;
    left: 15px;
    max-width: 50%;
    @include mobile{
      max-width: 100%;
    }
  }

  .wraper{
    position: relative;
    display: flex;
    align-items: flex-end;
  }

  .marciano{
    // width:85px;
    max-width: 15%;
    margin-right: 15px; 
  }

  .caja-texto{
    border-radius: 0px 40px 0px 40px;
    background-color: rgba(255, 255, 255, 0.7);
    padding: 5px 15px 5px 15px;
    margin-bottom: 5px;
    transform-origin: 0%;
    transform: scaleX(0);
    animation: caja-texto 500ms ease-in-out forwards;
    animation-delay: 1500ms;
  }

  .caja-texto > span{
    opacity: 0;
    animation: caja-texto-fade 500ms ease-in-out forwards;
    animation-delay: 2000ms;
  }

  .btn-entrar{
    font-size: 20pt;
    transition: opacity 500ms;
  }

  @keyframes caja-texto{
    0%{ transform: scaleX(0) }
    100%{ transform: scaleX(1) }
  }

  @keyframes caja-texto-fade{
    0%{ opacity: 0 }
    100%{ opacity: 1 }
  }
</style>

